import axios from 'axios'
import botsPrefixedUrl from './botsPrefixedUrl'

export default function (config = {}) {
    const instance = axios.create(config)

    instance.interceptors.request.use(config => {
        return {
            ...config,
            url: botsPrefixedUrl(config.url)
        }
    })

    instance.interceptors.response.use(
        res => res,
        err => {
            return Promise.reject(err.response ? err.response.data : err)
        }
    )

    return instance
}
